import { createApp } from 'vue'
import SearchModal from './components/SearchModal.vue'

// Initialize Vue app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const modalElement = document.getElementById('search-modal-app')

  if (modalElement) {
    // Mount the search modal component
    const app = createApp(SearchModal)
    app.mount('#search-modal-app')

    // Add click handler for search icon in navigation
    const openSearchBtn = document.getElementById('open-search-modal')
    if (openSearchBtn) {
      openSearchBtn.addEventListener('click', (e) => {
        e.preventDefault()
        // Dispatch custom event to open modal
        document.dispatchEvent(new CustomEvent('open-search-modal'))
      })
    }
  }
})
